// Configuration for the development environment. Angular swaps this file in via the
// fileReplacements entry for each build configuration in angular.json.
import type { Environment } from './environment.model';

export const environment: Environment = {
    production: false,
    ENVNAME: "DEVELOPMENT",
    DISABLE_CONSOLE: false,
    ENABLE_LOGGING: true,
    LOG_LEVEL: "debug",
    API_BASE_URL: "https://devapi.realworld.fi/api/v1",
    API_BASE_URL_V2: "https://devapi.realworld.fi/api/v2/market-place",
    API_BASE_URL_V3: "https://devapi.realworld.fi/api/v3/market-place",
    SOCKET_BASE_URL: "https://devapi.realworld.fi",
    WEB_SITE_URL: "https://devmarket.realworld.fi/",
    FILE_UPLOAD: "https://devapi.realworld.fi/api/v3",
    GOOGLE_ANALYTICS_KEY: "GTM-M5T3FD9F",
    BTC_EXPLORER_URL: "https://mempool.space/address/",
    "0x13882": {
        EXPLORER: "https://www.oklink.com/amoy",
        PROVIDER: "https://rpc-amoy.polygon.technology/",
        PROVIDERS: [
            "https://polygon-amoy.g.alchemy.com/v2/Fad0zhYYtcsOt7RzhxJw5_YzZWKjaue6",
            "https://polygon-amoy.infura.io/v3/87894195c22d497195974e3dfecda9db",
            "https://lb.drpc.live/polygon-amoy/Auz3ZAt_kE-AjENU_fJuBBMshWuqcQAR77UiMnlAuwl_"
        ],
        CHAIN_NETWORK: "0x13882",
        CHAINID: 80002,
        CURRENCY_NAME: "MATIC",
        CURRENCY_SYMBOL: "MATIC",
        CHAIN_NAME: "Polygon Testnet",
        ACCESS_CONTROL_CONTRACT: "0xDDE9256778596E949DEa33912c82312B1cd4066C",
        BORROW_LEND_CONTRACT: "0x27cB8E823B7e357B62DE0B4985dbf3261fAbEd51",
        EXCHANGE_CONTRACT: "0xE986659879107F408325120D0a154910545079C2",
        LOAN_IN_DAYS: false,
        FACTORY_ADDRESS: "0x12ba55372ec48125e35dE6b0a84866b681276Bf7",
        NFT_LOAN_CONTRACT_TEST: "0x94c9Fc969F2D83B95CEeD4B5Ce503BB14aB93200",
        NFT_LOAN_CONTRACT_DEV: "0xdAf8940bc70e121D22657Ae91920e5FD984aC290",
        SYNDICATE_POOL_CONTRACT: "0x08233A65886aD4f46F10ab8B6F9a124a895C517A",
        ONBOARD_CONTRACT: "0xB11Bd85FEd80F8e12cf7d71c54eB2a5469d92D9F"
    },
    WALLET_CONNECT_PROJECT_ID: "b6c201630414d0fd586cfc6add82cde7",
    DEFAULT_NETWORK: "80002",
    DEFAULT_CHAIN: "0x13882",
    PINATA_BASE_URL: "https://chocolate-magnificent-blackbird-410.mypinata.cloud/ipfs/",
    GOOGLE_LOGIN_PROVIDER: "398286696618-p0aem6s2cghcp62g4hgvkd7offm7ota4.apps.googleusercontent.com",
    ONE_OUNCE: "28.35g",
    TEN_TOLA_BAR: "116.64g",
    ONE_KILO_GRAM: "1000g",
    AUTO_LOGOUT_DURATION: 86400,
    AUTO_LOGOUT_TIMEOUT: 30,
    WHATSAPP_NUMBER: "13057469333",
    WHATSAPP_MESSAGE: "Hello RealWorld Support",
    CLIENT_ID: "com.realworld.bundle.backend",
    MIXPANEL_TOKEN: "75529d73b1337b35119a7ce2731ae1d7",
    ENABLE_MIXPANEL: true,
    ENABLE_TELEGRAM_ERROR_ALERTS: true,
    TELEGRAM_TRACK_TOAST_ERRORS: true,
};
